export default "__VITE_ASSET__D9__KO7J__"